<template>
  <!-- クライアント管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>取引先情報</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: clientRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li class="preika-form-message" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <ListSearchBox
        :value="keyword"
        label="会社名・担当者・住所・メールで絞り込む"
        placeholder="例: 株式会社○○、山田、東京"
        :count="keyword ? totalCount : null"
        @search="applyKeyword"
      />

      <!-- 0件は失敗ではないので、赤字の欄（errors）ではなく案内の字で、表のすぐ上に出す。 -->
      <p v-if="emptyNote" class="text-muted">{{ emptyNote }}</p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" nowrap>取引先企業名</th>
              <th scope="col" nowrap>取引先担当者名</th>
              <th scope="col" nowrap>電話番号</th>
              <th scope="col" nowrap>E-Mail</th>
              <th scope="col" nowrap>住所</th>
              <th scope="col" nowrap>更新者</th>
              <th scope="col" nowrap>更新日</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in client" :key="item.company_name">
              <td>
                <router-link
                  :to="{ name: clientInfo, params: { value: item } }"
                  >{{ item.company_name }}</router-link
                >
              </td>
              <td nowrap>{{ item.staff_name }}</td>
              <td nowrap>{{ item.telephone }}</td>
              <td nowrap>{{ item.email }}</td>
              <td>{{ item.address }}</td>
              <td nowrap>{{ item.updated_user }}</td>
              <td nowrap>{{ formatDate(item.updated_at) }}</td>
              <td nowrap>
                <button
                  v-on:click="openModal(item, index)"
                  class="btn btn-danger"
                >
                  削除
                </button>
                <!-- 削除モーダルコンポーネント呼出 -->
                <ClientDeleteModal
                  :draggable="true"
                  :resizable="true"
                  :val="postItem"
                  :loading="loading"
                  v-show="showModal"
                  @delete="deleteClient"
                  @close="closeModal"
                >
                </ClientDeleteModal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-page="currentPage"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
        <DeletedRowsPanel
          label="削除した取引先"
          list-url="/client/deleted"
          restore-url="/client/{id}/restore"
          :columns="[
            { key: 'name', label: '取引先企業名' },
            { key: 'staffName', label: '担当者' },
            { key: 'projectCount', label: '案件', suffix: '件' },
            { key: 'updatedUser', label: '最後に触った人' }
          ]"
          empty-message="削除した取引先はありません。"
          note="「戻す」で元に戻るのは取引先のみです。配下の案件は、案件の一覧から1件ずつ戻してください。"
          @restored="reloadAfterRestore"
        />
    </CCardBody>
  </CCard>
</template>

<script>
import DeletedRowsPanel from '@/components/DeletedRowsPanel'
import axios from "axios";
import ConstList from "./../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import ClientDeleteModal from "./ClientDeleteModal";
import VPagination from "vuejs-paginate";
import ListSearchBox from "@/common/ListSearchBox";
export default {
  name: "List",
  components: {
    DeletedRowsPanel,
    ClientDeleteModal,
    VPagination,
    ListSearchBox,
  },
  data() {
    return {
      // 削除画面モーダル
      showModal: false,
      // 削除画面へ渡すアイテム
      // 小窓（ClientDeleteModal、val: Object）は v-show で常に描かれ val.company_name を直接読むので、
      // null ではなく空の {} にする（文字の "" だと開発時に型の警告が行の数だけ出ていた）。
      postItem: {},
      // 削除用のID
      client_id: "",
      // 取得してきたクライアント情報のリスト
      client: [],
      deleted_flg: [],
      errors: [],
      // 0件のときの案内（失敗ではないので errors には入れない）
      emptyNote: '',
      clientRegister: "",
      clientInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // いま効いている絞り込みの言葉。空なら絞り込んでいない。
      keyword: "",
      totalCount: 0,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.clientRegister = ConstList.ROUTE_CLIENT_REGISTER;
    this.clientInfo = ConstList.ROUTE_CLIENT_INFO;
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/clients/list", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              keyword: this.keyword || undefined,
            },
          })
          .then((response) => {
            this.client = response.data;
            // コンソールログに一覧取得データを出力。
            this.emptyNote = this.client.length === 0 ? ConstList.EMPTY : '';
          })
          .catch((error) => {
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(requestFailureMessage(error));
            })
            .catch(() => {
              alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
            });
          });
      }
    },

    // モーダルを表示
    openModal: function (item) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.showModal = true;
    },

    // クライアントを削除
    deleteClient: function () {
      this.loading = true;
      this.client.forEach((value, i, array) => {
        if (this.postItem.id === array[i][ConstList.ID]) {
          this.client_id = this.postItem.id;
        }
      });
      // JSON形式のパラメータ
      const params = {
        id: this.client_id,
      };
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/client/delete", params, {
          headers: {
            // content-type指定。@requestBodyでサーバ側にてバインドするため。
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          alert(ConstList.DELETE_MESSAGE);
          this.showModal = false;
          window.location.reload();
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },

    // 削除した取引先を戻したあと、一覧だけを読み直す（画面ごと読み直すと、戻せたという文も節も消える）。
    reloadAfterRestore: function () {
      this.errors = [];
      this.callList();
      this.fetchTotalPages();
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },

    /**
     * 絞り込みを受ける。
     *
     * **ページを1へ戻す。**5ページ目のまま絞り込むと、結果が1ページ
     * しか無いときに空の表になる。件数も先に数え直す。
     */
    applyKeyword (keyword) {
      this.keyword = keyword
      this.currentPage = 1
      Promise.resolve(this.fetchTotalPages()).then(() => this.callList())
    },

    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/clients/count", {
          params: { keyword: this.keyword || undefined },
        })
        .then((response) => {
          this.totalCount = Number(response.data) || 0;
          this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
